import PageFooter from 'components/common/general/layouts/PageFooter';
import {
  getRFQProposalChecklistURL,
  RFQ_PROPOSAL_CARD_DATA,
} from 'global/checklists-helpers/RFQProposalChecklistHelper';
import useRfqQuoteUrlParams from 'global/hooks/useRfqQuoteUrlParams';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRFQProposalResponseStore } from 'store/pages/rfq/rfq-response/proposal-response/pageStore';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { StyledUploadButton } from './styles';
import ResponseDocumentList from './ResponseDocumentList';
import UploadDocumentModal from './UploadDocumentModal';

const RFQProposalResponseContent: React.FC = observer(() => {
  const history = useHistory();
  const { periodId, cartId } = useRfqQuoteUrlParams();
  const { isLoading, activeDocuments, uploadDocumentModalStore, getInitialData, completeStep } =
    useRFQProposalResponseStore();

  const [showUploadDocumentModal, setShowUploadDocumentModal] = useState(false);

  useEffect(() => {
    void getInitialData();
  }, []);

  const openUploadDocumentModal = (): void => setShowUploadDocumentModal(true);
  const closeUploadDocumentModal = (): void => setShowUploadDocumentModal(false);

  const onBack = (): void => {
    const checklistURL = getRFQProposalChecklistURL({ periodId, cartId });
    history.push(checklistURL);
  };

  const onStepComplete = async (): Promise<void> => {
    await completeStep(periodId, cartId);
    onBack();
  };

  return (
    <>
      <PageHeader
        title={RFQ_PROPOSAL_CARD_DATA.PROPOSAL_RESPONSE.title}
        subtitle={RFQ_PROPOSAL_CARD_DATA.PROPOSAL_RESPONSE.text}
        subtitleMaxWidth="51rem"
        spacing="WITH_ACTION_BELOW"
        onRedirect={onBack}
      />
      <StyledUploadButton color="primary" size="large" onClick={openUploadDocumentModal}>
        Upload Document
      </StyledUploadButton>
      <ResponseDocumentList documents={activeDocuments} loading={isLoading} />
      <PageFooter
        disableCompleteButton={isLoading || activeDocuments.length === 0}
        onComplete={onStepComplete}
        onBack={onBack}
      />
      {uploadDocumentModalStore && (
        <UploadDocumentModal
          show={showUploadDocumentModal}
          modalStore={uploadDocumentModalStore}
          onClose={closeUploadDocumentModal}
        />
      )}
    </>
  );
});

export default RFQProposalResponseContent;
